import { render, staticRenderFns } from "./lvsuo.vue?vue&type=template&id=b0831260&scoped=true"
import script from "./lvsuo.vue?vue&type=script&lang=js"
export * from "./lvsuo.vue?vue&type=script&lang=js"
import style0 from "./lvsuo.vue?vue&type=style&index=0&id=b0831260&prod&scoped=true&lang=less"
import style1 from "./lvsuo.vue?vue&type=style&index=1&id=b0831260&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0831260",
  null
  
)

export default component.exports